import * as z from "zod";
import { UserResponseDto } from "./user-dto";

export interface AuthResponseDto {
    user: UserResponseDto;
    accessToken: string;
    refreshToken?: string;
    refreshTokenExpireTime?: string;
}

export const authOtpSchema = z.object({
    employeeId: z.string().optional(),
    otp: z.number(),
});

export type AuthOtpDto = z.infer<typeof authOtpSchema>;

// export interface ILoginDtoError {
//   email?: string[];
//   password?: string[];
// }

// export interface AuthRefreshToken {}

// form zod validation schema
export const authLoginSchema = z
    .object({
        username: z.string().trim().min(1, { message: "Username is required" }),
        password: z.string().min(1, { message: "Password is required" }),
        platform: z.string().default("webAppAccess"),
    })
    .required();

// generate form types from zod validation schema
export type AuthLoginDto = z.infer<typeof authLoginSchema>;
